import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { OwnersManualsAppContext } from '../../contexts/OwnersManualsContext';
import { ManualType } from '../../enums/manualType';
import { SearchError } from '../../enums/searchError';
import { CarModel } from '../../models';
import { SearchForm } from '../search-form';
import styles from './styles.scss';

type ManualSearchDialogProps = RouteComponentProps & {
	carModel: CarModel;
	title: string;
	image: string;
	hasDigitalManuals: boolean;
	handleClose: () => void;
	isCurrentModel: boolean;
};

type ManualSearchDialogState = {
	isMarketAvailable: boolean;
	hasError: boolean;
};

class ManualSearchDialog extends React.Component<ManualSearchDialogProps, ManualSearchDialogState> {
	static contextType = OwnersManualsAppContext;
	context: React.ContextType<typeof OwnersManualsAppContext>;

	constructor(props: ManualSearchDialogProps) {
		super(props);
		this.state = {
			isMarketAvailable: true,
			hasError: false,
		};
	}

	componentWillReceiveProps(props: ManualSearchDialogProps) {
		this.setState({ hasError: false });
	}

	handleError = (error: SearchError) => {
		this.setState({ hasError: true });
		if (error !== SearchError.EmptyEditionParam) {
			this.context.services.trackingPrepare.trackSearchError(error, null, null);
		}
	};

	handleFormSubmit = async (productionPeriod: string, market: string, language: string, hasDigitalManuals: boolean) => {
		this.context.setTopicPilotData('', '', '');
		try {
			const manualsResult = await this.context.loadManuals(this.props.carModel.modelType, productionPeriod, market, language, '');
			if (!manualsResult.results.length) {
				throw 'emptyManualsResult';
			}
			if (manualsResult.results[0].manualType === ManualType.Digital) {
				this.context.services.trackingPrepare.trackOpenTPManual(
					this.props.carModel.modelFamily,
					this.props.carModel.modelType,
					manualsResult.results[0].digitalManual.partNumber
				);
				this.context.setTopicPilotData('', manualsResult.results[0].digitalManual.partNumber, manualsResult.results[0].digitalManual.uiLanguage);
			} else {
				this.props.history.push(`/Detail?model=${this.props.carModel.modelType}&edition=${productionPeriod}&market=${market}&manualLang=${language}`, {
					isCurrentModel: this.props.isCurrentModel,
				});
				this.context.services.trackingPrepare.trackSearchResult(
					manualsResult.results.length.toString(),
					true,
					this.props.carModel.modelFamily,
					this.props.carModel.modelType
				);
			}
		} catch (error) {
			this.context.setError('Search_Error_Title', 'Search_Error_Description');
		}
	};

	handleProductionPeriodChange = (isMarketAvailable: boolean) => {
		this.setState({ isMarketAvailable: isMarketAvailable });
	};

	render() {
		if (this.context.hasError) return null;

		return (
			<Dialog
				fullWidth={false}
				maxWidth={false}
				open={true}
				disableScrollLock={false}
				scroll={'paper'}
				onClose={this.props.handleClose}
				aria-labelledby='manual-search-dialog'
				className={styles['dialog']}
				id='dialog-cs-search'
			>
				<DialogContent className={styles['dialog-content']}>
					<div className={`${styles['header']}`}>
						<h2>{this.context.services.resourceProvider.getText(this.props.title)}</h2>
						<IconButton aria-label='close' data-test='btn-close-dialog' onClick={this.props.handleClose} className={`${styles['icon-close']}`}>
							<CloseIcon />
						</IconButton>
					</div>
					<img src={this.props.image} alt='' />
					<SearchForm
						onSubmit={this.handleFormSubmit}
						formClassName={styles['dialog-form']}
						onProductionPeriodChange={this.handleProductionPeriodChange}
						onError={this.handleError}
						model={this.context.model}
						noMarket={!this.state.isMarketAvailable && this.props.hasDigitalManuals}
					/>
				</DialogContent>
			</Dialog>
		);
	}
}

export default withRouter(ManualSearchDialog);
